import { IExtractedFields } from '../../appointments/recording/RecordingState';

/**
 * Keys that are displayed in the Bea comment bubble's fields card.
 * Used here to determine whether the bubble has visible field content,
 * and also by BeaCommentBubble for rendering the fields card.
 */
export const DISPLAYED_FIELD_KEYS: (keyof IExtractedFields)[] = [
    'careRecipientName',
    'diagnoses',
    'allergies',
    'medications',
    'address',
];

/** Returns true if the extracted fields contain at least one non-empty displayed field. */
export const hasExtractedFields = (fields?: IExtractedFields): boolean => {
    if (!fields) {
        return false;
    }
    return DISPLAYED_FIELD_KEYS.some(key => {
        const value = fields[key];
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return !!value;
    });
};
